module.exports = __webpack_public_path__ + "img/2.f869a993.png";